module.exports = __webpack_public_path__ + "img/5.2830eaf2.png";